(function () {
  function parseLines(text) {
    return text
      .split(/\r?\n/)
      .map(function (line) { return line.trim(); })
      .filter(Boolean)
      .map(function (line) {
        var parts = line.split(/[,\t|]+/).map(function (p) { return p.trim(); });
        return { sku: parts[0], qty: Math.max(1, parseInt(parts[1], 10) || 1) };
      });
  }

  function searchVariant(sku) {
    return fetch('/search/suggest.json?q=' + encodeURIComponent(sku) + '&resources[type]=product&resources[limit]=5')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        var match = products.find(function (p) {
          return (p.title && p.title.toLowerCase().indexOf(sku.toLowerCase()) !== -1) ||
            (p.handle && p.handle.toLowerCase() === sku.toLowerCase());
        }) || products[0];
        if (!match) return null;
        return fetch('/products/' + match.handle + '.js').then(function (r) { return r.json(); });
      });
  }

  function findVariantId(product, sku) {
    var skuLower = sku.toLowerCase();
    var variant = product.variants.find(function (v) {
      return (v.sku && v.sku.toLowerCase() === skuLower) ||
        (v.barcode && String(v.barcode).toLowerCase() === skuLower);
    });
    if (variant) return variant.id;
    if (product.variants.length === 1) return product.variants[0].id;
    return null;
  }

  function addToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('Cart add failed');
      return r.json();
    });
  }

  document.querySelectorAll('[data-tcb-bulk-order]').forEach(function (root) {
    var textarea = root.querySelector('[data-tcb-bulk-lines]');
    var submit = root.querySelector('[data-tcb-bulk-submit]');
    var status = root.querySelector('[data-tcb-bulk-status]');
    if (!textarea || !submit) return;

    submit.addEventListener('click', function () {
      var lines = parseLines(textarea.value);
      if (!lines.length) {
        status.hidden = false;
        status.textContent = 'Add at least one line: SKU, quantity';
        return;
      }

      submit.disabled = true;
      status.hidden = false;
      status.textContent = 'Looking up SKUs…';

      var chain = Promise.resolve([]);
      var failures = [];

      lines.forEach(function (line) {
        chain = chain.then(function (items) {
          return searchVariant(line.sku).then(function (product) {
            if (!product) {
              failures.push(line.sku);
              return items;
            }
            var id = findVariantId(product, line.sku);
            if (!id) {
              failures.push(line.sku);
              return items;
            }
            items.push({ id: id, quantity: line.qty });
            return items;
          });
        });
      });

      chain
        .then(function (items) {
          if (!items.length) throw new Error('none');
          return addToCart(items);
        })
        .then(function () {
          if (failures.length) {
            status.textContent = 'Added available items. Not found: ' + failures.join(', ');
          } else {
            status.textContent = 'Added to cart — redirecting…';
            window.location.href = '/cart';
          }
        })
        .catch(function () {
          status.textContent = failures.length
            ? 'Could not find: ' + failures.join(', ') + '. Try part # search or contact us for bulk quotes.'
            : 'Could not match those SKUs. Try part # search or request a bulk quote.';
        })
        .finally(function () {
          submit.disabled = false;
        });
    });
  });
})();
